import { openDialog, closeDialog } from './dialog';
import './file-input';

const $dialog = document.getElementById('dialog-dmca');

if ($dialog) {
  const $form = $dialog.querySelector('form');
  const $inputName = $form.querySelector('input[name="dmca-name"]');
  const $inputEmail = $form.querySelector('input[name="dmca-email"]');
  const $inputUrl = $form.querySelector('input[name="dmca-url"]');
  const $inputFile = $form.querySelector('input[name="dmca-file[]"]');
  const $labelFile = $inputFile.nextElementSibling.firstElementChild;
  const $button = $form.querySelector('.btn');

  const removeErrors = () => {
    $form.querySelectorAll('input').forEach(($input) => {
      $input.classList.remove('has-error');
    });
  };

  $form.addEventListener('submit', (event) => {
    event.preventDefault();
    $button.disabled = true;
    removeErrors();

    fetch($form.action, {
      method: $form.method,
      body: new FormData($form),
      cache: 'no-cache',
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && data.errors) {
          if (data.errors.name) {
            $inputName.parentElement.classList.add('has-error');
          }

          if (data.errors.email) {
            $inputEmail.parentElement.classList.add('has-error');
          }

          if (data.errors.email) {
            $inputUrl.parentElement.classList.add('has-error');
          }

          if (data.errors.file) {
            $inputFile.parentElement.classList.add('has-error');
          }

          setTimeout(removeErrors, 500);
        } else {
          closeDialog('dialog-dmca');
          openDialog('dialog-dmca-success');
          $form.reset();
          $labelFile.textContent = $labelFile.dataset.initialText;
        }
      })
      .finally(() => {
        $button.disabled = false;
      });
  });
}
